export function getPriceRangeLabel(minPrice, maxPrice) {
  if (
    minPrice === null || minPrice === undefined ||
    maxPrice === null || maxPrice === undefined
  ) return '';

  if (minPrice === 0 && maxPrice === 0) {
    return '-';
  }

  const format = (value) => {
    if (value >= 1_000_000) {
      return `KES${(value / 1_000_000).toFixed(1)}M`;
    }
    if (value >= 1_000) {
      return `KES${(value / 1_000).toFixed(1)}K`;
    }
    return `KES${value}`;
  };

  return `${format(minPrice)} - ${format(maxPrice)}`;
}